<input class="form-control ui-datepicker"
       [placeholder]="placeholder ? placeholder : ('common.datepickerPlaceholder' | translate)"
       [class.is-open]="dp?.isOpen()"
       [id]="controlName"
       [disabled]="disabled"
       [name]="controlName"
       autocomplete="off"

       [placement]="placement"
       [maxDate]="getNgbDate(maxDate)"
       [minDate]="getNgbDate(minDate)"

       [(ngModel)]="ngbModel"
       [dayTemplate]="customDay"

       (ngModelChange)="onDateChanged($event)"
       (click)="onClick($event)"
       (navigate)="onMonthUpdated($event)"
       ngbDatepicker
       #dp="ngbDatepicker"/>
<ng-template #customDay
             let-date="date"
             let-currentMonth="currentMonth"
             let-selected="selected"
             let-disabled="disabled"
             let-focused="focused">
  <div class="btn-light "
       [class.today]="isToday(date)"
       [class.focused]="focused"
       [class.bg-pink]="selected"
       [class.selected]="selected"
       [class.disabled]="disabled">
    {{ date.day }}
  </div>
</ng-template>
